// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"631df113","618":"b976572a","656":"061e67ff","895":"411aaca4"}[chunkId] + ".chunk.js";
};